import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "white",
  },
  section: {
    width:'49%',
    // margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  company_name: {
    Font: "Arial",
    fontWeight: 900,
    fontSize: 9,
  },
  company_adress: {
    Font: "Arial",
    fontSize: 8,
  },
  paddingTop10: {
    paddingTop: 10,
  },
  cell: {
    marginRight: 10,
    textAlign: "right",
  },
  tableRow: {
    // display: 'flex',
    flexDirection: "row",
  },
  col1: {
    display: "flex",
    flexDirection: "row",
    width: 55, // fixed width for qty
    flexShrink: 0, // prevent shrinking
  },
  col3: {
    display: "flex",
    flexDirection: "row",
    textAlign:'left',
    width: 300,
  },
  col4: {
    display: "flex",
    flexDirection: "row",
    width: 70,
  },
  col5: {
    display: "flex",
    flexDirection: "row",
    width: 70,
  },
  floatright: {
    alignItems: "flex-end",
  },
  colComputations1: {
    width: 255,
  },
  colComputations2: {
    width: 70,
  },
  row: {
    display: "flex",
    flexDirection: "row",
  },
  textcenter: {
    textAlign: "center",
  },
  title:{
    textAlign: "center",
    Font: "Arial",
    fontWeight: 900,
    fontSize: 11,
  },
  pageNumbers: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 6,
  },
});

export function PdfDocument(props) {
  // console.log('thiss',props);
  // console.log(`[${performance.now()}] Function A executed`);
  var duplicatePrint = [0, 1];
  return (
    <Document>
      <Page size="A4" style={styles.page} orientation="landscape" wrap>
      
        {duplicatePrint.map((row, ind) => (
          <View style={styles.section} key={ind}>
                      <View style={{ marginVertical: 10 }}>
                  <Text style={styles.title}>Account Upgrade Wholesale Set</Text>
                </View>
            {/* HEADER SECTION DUBAI */}
            {!props.headers.TRN == "" ? (
              <View>
                <Text style={styles.company_name}>TAX INVOICE</Text>
                <Text style={styles.company_adress}>
                  JCP Premiere General Trading LLC
                </Text>
                {/* <Text style={styles.company_adress}>
                  TRN: {props.headers.TRN}
                </Text>
                <Text style={[styles.company_name, styles.paddingTop10]}>
                  Invoice No.: {props.headers.invoice_no}
                </Text> */}
              </View>
            ) : null}
            {/* HEADER SECTION */}
            <Text style={styles.company_name}>{props.headers.companyname}</Text>
            {/* Address */}
            <Text style={styles.company_adress}>
              {props.headers.companyaddress}
            </Text>
            {/* Contact No. and Website */}
            {/* <Text style={styles.company_adress}>
              {props.headers.companyphone +
                " | " +
                props.headers.companywebsite}
            </Text> */}

            {/* Activation No. */}
            {!props.headers.idno == "" ? (
              <Text style={styles.company_name}>ID#: {props.headers.idno}</Text>
            ) : null}

            {/* Package Sales Information */}
            {/* Atype */}
            {/* Date */}
            <Text style={styles.company_name}>Transaction Date: {props.headers.date_created} (Philippine Time)</Text>
            <Text style={styles.company_name}>Payment Date: {props.headers.ph_date_paid} (Philippine Time)</Text>
            {props.country == "Philippines" ? null :<Text style={styles.company_name}>Payment Date: {props.headers.date_paid} ({props.country} Time)</Text>}

            {/* Sold To */}
            <Text style={styles.company_name}>
              Sold To: {props.soInfo.fname} {props.soInfo.mname || " "}{" "}
              {props.soInfo.lname}
            </Text>
            {/* Package */}
            {props.packages.map((pkg, index) => (
              <Text key={index} style={styles.company_name}>Set: {pkg.package_name}</Text>
            ))}
            
            {/* Reference No. */}
            <Text style={styles.company_name}>
              Reference No.: {props.headers.reference_no}
            </Text>
            {/* Location */}


            {/* Item Details */}
            <View style={[styles.tableRow, styles.paddingTop10]}>
              <View style={[styles.tableRow, styles.col1]}>
                <Text style={[styles.company_adress, styles.cell]}>Qty</Text>
              </View>
              <View style={[styles.tableRow, styles.col3]}>
                <Text style={[styles.company_adress]}>
                  Description
                </Text>
              </View>
            </View>
            {!props.items == ""
              ? props.items.map((row, ind) => (
                  <View style={[styles.tableRow, styles.paddingTop10]}>
                    <View style={[styles.tableRow, styles.col1]}>
                      <Text style={[styles.company_adress, styles.cell]}>
                        {props.items[ind].qty}
                      </Text>
                    </View>

                    <View style={[styles.tableRow, styles.col3]}>
                      <Text style={[styles.company_adress]}>
                        {props.items[ind].itemname}
                      </Text>
                    </View>
                    <View style={[styles.tableRow, styles.col4]}>
                      <Text style={[styles.company_adress, styles.cell]}>
                        {props.items[ind].price}
                      </Text>
                    </View>
                  </View>
                ))
              : null}

            <View break>
              {/* Signature */}
              <Text style={[styles.company_name, styles.paddingTop10]}>
                I hereby certify that I receive the items in good condition and
                complete quantity.
              </Text>
              <Text style={[styles.company_name, styles.paddingTop10]}>
                Received By: __________________________ Received Date:_________.
              </Text>
              <Text style={[styles.company_name, styles.paddingTop10]}>
                Prepared By: ___________. Checked By: _____________. Released
                By: _____________.
              </Text>
              {/* <Text
                style={styles.pageNumbers}
                render={({ pageNumber, totalPages }) =>
                  `Page ${pageNumber} | ${props.headers.trandate} - ${props.headers.trantime}`
                }
              /> */}
            </View>
          </View>
        ))}
      </Page>
    </Document>
  );
}
